// import axios from "axios";

// const api = axios.create({
//   baseURL: process.env.NEXT_PUBLIC_API_BASE_URL, // http://localhost:4000/api/v1
//   withCredentials: true, // only if you plan to use cookies
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

// export default api;


// lib/axios.js
import axios from "axios";
import useAuthStore from "@/stores/useAuthStore";

const apiBase = process.env.NEXT_PUBLIC_API_BASE_URL || "/api/v1";
const api = axios.create({
  baseURL: apiBase,
});

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().accessToken;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const originalRequest = error.config;
    const { refreshToken, setAuth, clearAuth } = useAuthStore.getState();

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      if (!refreshToken) {
        clearAuth();
        // window.location.href = "/auth";
        return;
      }

      try {
        const { data } = await axios.post(
          `${apiBase}/auth/refresh`,
          { refreshToken }
        );

        setAuth({
          accessToken: data.accessToken,
          refreshToken: data.refreshToken || refreshToken, // rotate if new provided
          remember: useAuthStore.getState().remember,
        });

        originalRequest.headers.Authorization = `Bearer ${data.accessToken}`;
        return api(originalRequest);
      } catch (err) {
        clearAuth();
        window.location.href = "/auth";
      }
    }

    return Promise.reject(error);
  }
);

export default api;
